import React, { Component } from 'react';

import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';

import Dialog from '../../components/Dialog/Dialog';
import { ButtonSecondary, ButtonDefault } from '../../components/Button/Button';

export class DialogReabrirInscricao extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            dialog: {
                open: false,
                title: null,
                text: null,
                id: null,
                loading: false,
                severity: null,
            },  
        }
    }

    // LOADING AO SUBMETER MODAL
    loading = () => {
        this.setState({
            dialog: {
                ...this.state.dialog,
                loading: true,
            }
        });
    }

    // AÇÕES MODAL
    actions = () => {
        return (
            <>
                <ButtonSecondary 
                    onClick={() => this.props.handleConfirm(this.state.dialog.id)}
                    startIcon={this.state.dialog.loading ? <CircularProgress size={16} /> : <CheckOutlinedIcon />}
                    disabled={this.state.dialog.loading}
                    style={{ margin: 4 }}
                    name="Reabrir Inscrição"
                />
                <ButtonDefault 
                    onClick={this.close}
                    startIcon={<ClearOutlinedIcon />}
                    style={{ margin: 4 }}
                    name="Cancelar"
                />
            </>
        )
    }

    // FECHAR MODAL
    close = () => {
        this.setState({ 
            dialog: { 
                open: false, 
                title: null,
                text: null,
                id: null,
                loading: false,
                severity: null,
            }
        })
    }

    render() {
        return (
            <>
                <Dialog
                    openDialog={this.state.dialog.open}
                    title={this.state.dialog.title}
                    closeDialog={this.close}
                    actions={this.actions()}
                    fullWidth={true}
                    maxWidth={"md"}
                >

                    {this.state.dialog.severity ?
                        <Alert severity={this.state.dialog.severity} style={{ marginBottom: 16 }}>
                           <b>Atenção: </b> {this.state.dialog.text}
                        </Alert>
                        :
                        this.state.dialog.text
                    }

                    
                </Dialog>
            </>
        )
    }
}

export default DialogReabrirInscricao;